export default "__VITE_ASSET__C0dxzB7r__"